// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Xs-z","tupacHeader":"Ys-z","tupacHeader2":"Zs-z","tupacMenu":"_s-z","tupacMenu2":"at-z","tupacMain":"bt-z","tupacMain2":"ct-z"};